package shared.content

import shared.config.WebsiteCOs
import shared.models.PageSEO
import shared.models.ProductCard

object ReaptiveHomeContent {

    val pageSeo = PageSEO(
        title = "Reaptive \u2014 Building products that connect people",
        description = "Reaptive builds consumer apps focused on human connection. Makers of Astro Navya (your AI Vedic astrologer) and Peekopals (your AI friend group).",
        ogTitle = "Reaptive \u2014 Building products that connect people",
        ogDescription = "Makers of Astro Navya and Peekopals. Consumer apps designed for meaningful relationships, from the cosmos to your friend group.",
        ogImage = WebsiteCOs.defaultOgImage,
        twitterImageAlt = "A smiling woman in a red velvet dress against warm golden lights",
        canonicalPath = "/",
        keywords = listOf(
            "Reaptive",
            "Astro Navya",
            "Peekopals",
            "AI astrology",
            "AI companion"
        )
    )

    const val heroHeading = "Building products that connect people"
    const val heroSubtitle = "We believe that meaningful relationships deserve beautifully designed, delightful experiences. From the cosmos to your friend group."
    const val productsHeading = "Our products"
    const val productsSubtitle = "Consumer apps focused on human connection"
    const val contactHeading = "Get in touch"
    const val contactSubtitle = "Questions, partnerships, or just want to say hello?"

    val astroNavya = ProductCard(
        name = "Astro Navya",
        tagline = "AI Vedic astrology",
        url = "https://www.astronavya.com",
        description = "Meet Navya — your personal AI Vedic astrologer. Get insightful, culturally-rooted astrology readings powered by AI, tailored to your birth chart and life questions."
    )

    val peekopals = ProductCard(
        name = "Peekopals",
        tagline = "Your AI friend group",
        url = "https://www.peekopals.com",
        description = "Meet 6 unique AI companions you can chat with like friends and follow on a social feed that updates every day. Each has their own personality, evolving storyline, and a life of their own — free at launch."
    )
}
